<template>
    <div class="summarizing_list">
        <div class="summarizing_header">
            <div class="accountStated_box">
                <Button type="info" class="actions_btn" @click="onPrint()">
                    打印
                </Button>
                <Button type="info" class="actions_btn" @click="toAccount()">
                    明细
                </Button>
            </div>
            <div class="allTypeMoney">
                总台数：{{ tatolNumber }}台；
                本月安装数：{{ nowMouthNum }}台；
                总计：{{ allTypeMoney }}元
            </div>
        </div>
        <div class="summarizing_center">
            <el-table :data="tableList" class="table_box" height="calc(100vh - 300px)"
                :header-cell-style="{ background: '#f8f8f9', color: '#515a6e' }">
                <el-table-column type="index" width="80">
                    <template slot="header">
                        序号
                    </template>
                </el-table-column>
                <el-table-column min-width="180" align="left">
                    <template slot="header">
                        设备类型
                    </template>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.typeName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column min-width="100" align="left">
                    <template slot="header">
                        数量
                    </template>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.facilityNum }}
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column min-width="260" align="center">
                    <template slot="header">
                        月费用
                    </template>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.typeName }}
                        </div>
                    </template>
                </el-table-column> -->
                <el-table-column min-width="180" align="left">
                    <template slot="header">
                        小计费用
                    </template>
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.typeMoney }}元
                        </div>
                    </template>
                </el-table-column>

                <!-- <el-table-column align="center" min-width="90">
                <template slot="header">
                  <span>操作</span>
                </template>
                <template slot-scope="scope">
                  <div>
                    <span class="operation_btn" @click="editMember(scope.row)">编辑</span>
                    <span
                      class="operation_btn"
                      style="margin-right: 0"
                      @click="delMemberModal(scope.row)"
                      >删除</span
                    >
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
        </div>
        <!-- <Collapse style="width: 100%" v-model="value1">
            <Panel style="width: 100%" name="2">
                展开搜索条件
                <Form ref="formQuery" :label-width="75" :label-position="left" :label-colon="true" :model="query" style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            " slot="content">
                    <Col span="3" :xxl="6" :xl="4" :lg="6" :md="8" :sm="12" :xs="24" style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              ">
                    <Button icon="ios-search" type="info" @click="search" style="width: 90px">搜索
                    </Button>
                    <Button icon="ios-close-circle" type="error" @click="clearFilter"
                        style="width: 90px; margin-right: 15px">重置
                    </Button>
                    </Col>
                    <template>

                    </template>
</Form>
</Panel>
</Collapse> -->
    </div>
</template>

<script>
// import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
const customerId = window.localStorage.getItem("customerId")
import dayjs from 'dayjs';
export default {
    // extends: baseList,
    components: {

    },
    data() {
        return {
            query: {

            },
            filters: [
                // {
                //     label: "设备类型",
                //     KeyEnter: this.search,
                //     name: "",
                //     value: "typeName",
                //     type: "input",
                // },

            ],
            tableList: [],
            allTypeMoney: "",
            tatolNumber: "",
            nowMouthNum: ""
        };
    },
    created() {
        let query = this.$route.query;
        this.query.customerId = Number(customerId) === 0 ? window.localStorage.getItem("customerIdClick") : Number(customerId)
        this.query.begin = dayjs(query.payMonthTime).startOf('month').format("YYYY-MM-DD HH:mm:ss")
        this.query.end = dayjs(query.payMonthTime).endOf('month').format("YYYY-MM-DD HH:mm:ss")
        this.onSummarizingList()
    },
    methods: {
        onPrint() {
            let customerTime = this.$route.query.payMonthTime.slice(0, 7)
            customerTime = customerTime.split('-')
            customerTime[1] = customerTime[1] - 1
            customerTime = customerTime.join("-")
            customerTime = dayjs(customerTime).format("YYYY年M月")
            let customerNameStr = Number(customerId) === 0 ? window.localStorage.getItem('customerNameClick') : window.localStorage.getItem("customerName")
            let tableListNew = this.tableList.map((item, index) => ({
                index: index + 1,
                ...item
            }))
            printJS({
                printable: tableListNew,
                properties: [
                    { field: 'index', displayName: '编号' },
                    { field: 'typeName', displayName: '设备类型' },
                    { field: 'facilityNum', displayName: '数量' },
                    { field: 'typeMoney', displayName: '小计费用（元）' },
                ],
                gridHeaderStyle: "border:none;",
                gridStyle: "border:none",
                header: `
                <h2 class="custom-h2">${customerNameStr}${customerTime}收费表 总表</h3>
                <h3 class="custom-h3">总台数：${this.tatolNumber}台；本月安装数：${this.nowMouthNum}台；总计：${this.allTypeMoney}元</h3>`,
                style: `
                        .custom-h2 { text-align: center;}
                        .custom-h3 { text-align:right; }
                        th{
                        font-size:14px;
                        border-bottom: 1px solid #999 !important;
                        padding: 10px 0;
                        }
                        td{
                        font-size:14px;
                        border-bottom: 1px solid #999 !important;
                        padding: 10px 0;
                        text-align:center;
                        }
                        td:nth-last-child(1){
                        text-align: left;
                        } 
                        th:nth-last-child(1){
                        text-align: left !important;
                        }
                        td:nth-last-child(3){
                        text-align: left;
                        }
                        th:nth-last-child(3){
                        text-align: left !important;
                        }
                        `,
                type: 'json'
            })
        },
        onSummarizingList() {
            let q = this.query
            $utils.api.load("/admin/system/facilityPay/listType", q, "get").then(res => {
                if (res.code == 200) {
                    let list = res.rows
                    this.tableList = list
                    let all = 0
                    let allA = 0
                    list.forEach(item => {
                      console.log(all,'==========')
                        all = all + Number(item.typeMoney ? item.typeMoney : 0)
                        allA = allA + Number(item.facilityNum ? item.facilityNum : 0)
                    })
                  console.log(all)
                    this.allTypeMoney = Number(all.toFixed(2))
                    this.tatolNumber = Number(allA.toFixed(2))
                    this.nowMouthNum = list[0].nowMouthNum ? list[0].nowMouthNum : 0

                }
            })
        },
        toAccount() {
            $utils.url.push({
                name: "account_stated",
                query: this.query,
            });
        },
    }
};
</script>
<style scoped lang="less">
.summarizing_list {
    width: 100%;
    padding: 10px 20px;
    box-sizing: border-box;

    .summarizing_header {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: end;

        .accountStated_box {
            .actions_btn {
                margin-left: 20px;
            }
        }

        .allTypeMoney {
            font-size: 24px;
            font-weight: bold;
            margin-top: 20px;
        }
    }
}
</style>
